import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './component/Footer.js';
import Login from './Login.js';
import Logout from './Logout.js';
import SignUp from './SignUp.js';
import Create from './Create.js';
import Home from './Home.js';
import PasswordReset from './PasswordReset.js';
import Result from './Result.js';
import Form from './Form.js';
import FormDraft from './FormDraft.js';
import Pricing from './Pricing.js';
import MyAccount from './MyAccount.js';
import Courses from './Courses.js';
import ConsoleUser from './ConsoleUser.js';
import ConsoleForm from './ConsoleForm.js';
import FormTemplate from './FormTemplate.js';
import PrivatePolicy from './PrivatePolicy.js';
import TermsOfUse from './TermsOfUse.js';


const App = () => {
  return (
    <Router>
      <div>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/signup" element={<SignUp />} />
          <Route exact path="/create" element={<Create />} />
          <Route exact path="/passwordreset" element={<PasswordReset />} />
          <Route exact path="/result" element={<Result />} />
          <Route exact path="/form" element={<Form />} />
          <Route exact path="/formdraft" element={<FormDraft />} />
          <Route exact path="/pricing" element={<Pricing />} />
          <Route exact path="/myaccount" element={<MyAccount />} />
          <Route exact path="/courses" element={<Courses />} />
          <Route exact path="/consoleuser" element={<ConsoleUser />} />
          <Route exact path="/consoleform" element={<ConsoleForm />} />
          <Route exact path="/formtemplate" element={<FormTemplate />} />
          <Route exact path="/logout" element={<Logout />} />
          <Route exact path="/privacy-policy" element={<PrivatePolicy />} />
          <Route exact path="/terms-of-use" element={<TermsOfUse />} />
        </Routes>
        <Footer />
        </div>
    </Router>
  );
};

export default App;